// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29w9-","content":"styles_content__1Q5xW","row":"styles_row__15M5r","footer":"styles_footer__2ZqYt","phraseLength":"styles_phraseLength__qlmMu"};